/**
 * playmello-custom.js - Vanilla Interactive Scripts for sitzkunst.shop
 */

document.addEventListener('DOMContentLoaded', function () {
  // 1. Accordion Toggle
  const accordionHeaders = document.querySelectorAll('.pm-accordion-header');
  accordionHeaders.forEach(function (header) {
    header.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Toggle current
      this.setAttribute('aria-expanded', !isExpanded);
      content.style.display = isExpanded ? 'none' : 'block';
      const icon = this.querySelector('.pm-accordion-icon');
      if (icon) icon.textContent = isExpanded ? '+' : '−';
    });
  });

  // 2. Scroll Reveal Animations
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pm-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.pm-benefit-card, .pm-product-card, .pm-feature-item').forEach(function (el) {
      observer.observe(el);
    });
  }
});
